const reloadKey = "route-chunk-reload";
const noticeId = "route-chunk-error";

function removeNotice() {
    document.getElementById(noticeId)?.remove();
}

// A failed initial route can prevent Vue from mounting. Keep the fallback
// independent of Vue so a manual retry is still available in that case.
function showRetry(i18n, target) {
    removeNotice();
    const notice = document.createElement("section");
    notice.id = noticeId;
    notice.setAttribute("role", "alert");
    notice.style.cssText = "position:fixed;inset:0;z-index:10000;background:white;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:2rem;text-align:center";

    const message = document.createElement("p");
    message.textContent = i18n.t("navigation.loadError");
    const retry = document.createElement("button");
    retry.type = "button";
    retry.className = "button button--primary";
    retry.textContent = i18n.t("navigation.retryLoad");
    retry.addEventListener("click", () => window.location.assign(target));

    notice.appendChild(message);
    notice.appendChild(retry);
    document.body.appendChild(notice);
    retry.focus();
}

export function installChunkRecovery(router, i18n) {
    let target;
    router.beforeEach((to, from, next) => {
        target = to.fullPath;
        next();
    });

    router.afterEach(to => {
        if (typeof window === "undefined") return;
        removeNotice();
        try {
            if (window.sessionStorage.getItem(reloadKey) === to.fullPath) {
                window.sessionStorage.removeItem(reloadKey);
            }
        } catch {
            // Recovery also works when browser storage is unavailable.
        }
    });

    router.onError(error => {
        if (typeof window === "undefined") return;
        if (router.app?.$logErrorsAndExceptions) {
            router.app.$logErrorsAndExceptions("router.onError", error);
        } else {
            console.error(error);
        }

        const isChunkError = error.name === "ChunkLoadError" ||
            error.code === "CSS_CHUNK_LOAD_FAILED" ||
            /Loading (?:CSS )?chunk .* failed/i.test(error.message || "");
        if (!isChunkError || !target) return;

        try {
            if (window.sessionStorage.getItem(reloadKey) !== target) {
                // Survives a full reload, preventing a loop while offline.
                window.sessionStorage.setItem(reloadKey, target);
                window.location.assign(target);
                return;
            }
        } catch {
            // Without storage, offer a manual retry instead of risking a loop.
        }
        showRetry(i18n, target);
    });
}
